import Progressbar from 'react-js-progressbar';

const CircleProgressBar = ({ percentage, blue, semicircle, children }) => {
    return (
        <Progressbar
            input={percentage}
            pathWidth={10}
            pathColor={blue ? ['#6A92FF', '#8764FF'] : ['#E632BE', '#F44197']}
            trailWidth={10}
            trailColor='#F4F2FE' 
            textStyle={{ display: 'none' }}
            shape={semicircle ? 'arc' : 'full circle'}
        >
            {children}
        </Progressbar>
    )
}

export default CircleProgressBar;